import {
  useMutation,
  type MutationHookOptions,
  type MutationTuple,
  type TypedDocumentNode,
} from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateContentTagsDocument } from './update.generated';

const useUpdate = <T, U>(
  document: TypedDocumentNode<T, U>,
  options: MutationHookOptions<T, U>,
): MutationTuple<T, U> => {
  const { t } = useTranslation();
  return useMutation(document, {
    ...useNotifications(document, {
      failure: t('api.content_tags.update_error'),
      success: t('api.content_tags.update_success'),
    }),
    ...options,
  });
};

export const useUpdateContentTags = (options: ApiOptions<typeof UpdateContentTagsDocument> = {}) =>
  useUpdate(UpdateContentTagsDocument, options);
